import { UseStore } from '../../../../types/zustand'
import { useContextStore, useContextStoreApi } from '../../../../utils/zustand'
import { WebOfficeStoreContext } from '../contexts/WebOfficeStoreContext'
import { WebOfficeStore } from '../store/interface'

export const useWebOfficeStore: UseStore<WebOfficeStore> = selector => {
  return useContextStore(WebOfficeStoreContext, selector)
}

export const useWebOfficeStoreApi = () => {
  return useContextStoreApi(WebOfficeStoreContext)
}
